import { Coffee, CreditCard, Hotel, ShieldCheck, ShieldX } from "lucide-react";
import { PromoBadges, MemberTeaser } from "@/components/customer/PromoBadges";
import { idr } from "@/lib/api";
import { useT, useLoc } from "@/lib/i18n";

export const PlanPerks = ({ rp }) => { const t = useT(); return (
  <div className="flex flex-col gap-1 text-sm">
    <span className={`flex items-center gap-1.5 ${rp.breakfast_included ? "font-medium text-[#00A698]" : "text-slate-500"}`}>
      <Coffee className="h-4 w-4" /> {t(rp.breakfast_included ? "Termasuk sarapan" : "Tanpa sarapan")}
    </span>
    <span className={`flex items-center gap-1.5 ${rp.refundable ? "font-medium text-[#00A698]" : "text-slate-500"}`}>
      {rp.refundable ? <ShieldCheck className="h-4 w-4" /> : <ShieldX className="h-4 w-4" />} {t(rp.refundable ? "Pembatalan gratis" : "Tidak dapat dikembalikan")}
    </span>
    <span className="flex items-center gap-1.5 font-medium text-slate-700">
      {rp.payment_type === "pay_at_hotel" ? <Hotel className="h-4 w-4 text-[#5392F9]" /> : <CreditCard className="h-4 w-4 text-[#5392F9]" />}
      {t(rp.payment_type === "pay_at_hotel" ? "Bayar di hotel — tanpa bayar sekarang" : "Bayar sekarang (prepaid)")}
    </span>
  </div>
); };

export default function RatePlanRow({ room, plan, fits, onBook }) {
  const { rate_plan: rp, quote: q } = plan;
  const t = useT();
  const loc = useLoc();
  const ok = q.bookable && fits;
  const disc = Math.round(q.total_discount_percent);
  return (
    <div data-testid={`plan-row-${room.id}-${rp.id}`} className="grid grid-cols-1 gap-4 p-5 sm:grid-cols-[1fr_220px]">
      <div className="space-y-2">
        <p className="font-heading font-bold text-slate-900">{loc(rp, "name")}</p>
        <PlanPerks rp={rp} />
        <PromoBadges promos={q.promotions} testid={`plan-promos-${room.id}-${rp.id}`} />
      </div>
      <div className="flex flex-col justify-end gap-0.5 text-right">
        {disc > 0 && <span className="ml-auto w-fit rounded bg-[#E1231A] px-2 py-0.5 text-xs font-bold text-white">{t("HEMAT {n}%", { n: disc })}</span>}
        {disc > 0 && <p className="text-xs text-slate-400 line-through">{idr(q.base_avg_per_night)}</p>}
        <p data-testid={`plan-price-${room.id}-${rp.id}`} className="whitespace-nowrap font-heading text-2xl font-extrabold text-[#E1231A]">{idr(q.avg_per_night)}</p>
        <p className="text-xs text-slate-500">{t("per kamar/malam")}</p>
        <MemberTeaser price={q.member_avg_per_night} idr={idr} testid={`plan-member-price-${room.id}-${rp.id}`} />
        <p className="text-xs text-slate-500">{t("Total {n} malam:", { n: q.nights })} <b className="text-slate-800">{idr(q.subtotal)}</b></p>
        {ok && q.available <= 3 && <p className="text-xs font-semibold text-[#FF567D]">{t("Sisa {n} kamar!", { n: q.available })}</p>}
        <button data-testid={`book-plan-${room.id}-${rp.id}`} disabled={!ok} onClick={() => onBook(room, rp)}
          className="mt-2 rounded-lg bg-[#5392F9] px-4 py-2.5 font-heading font-bold text-white transition-colors hover:bg-[#3B7BE6] disabled:bg-slate-300">
          {t(!fits ? "Kapasitas kurang" : q.bookable ? "Pesan Sekarang" : "Tidak tersedia")}
        </button>
      </div>
    </div>
  );
}
